<template>
  <v-app id="app">
    <router-view />
  </v-app>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch("readData");
  }
};
</script>
<style lang="scss">
#app {
  font-family: Avenir Book, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;
}
</style>
